module.exports = __webpack_public_path__ + "img/youtube-icon.ea30dae1.svg";